// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-folders-list__container[data-v-361226e0]{max-height:178px;overflow-y:auto}@media (max-width: 499px){.media-folders-list__container.blocked-for-deletion[data-v-361226e0]{display:none}}@media (min-width: 500px){.media-folders-list__container.blocked-for-deletion[data-v-361226e0]{opacity:0.5;cursor:not-allowed !important}}\n", ""]);
// Exports
module.exports = exports;
